<script>
  import About from "./About.svelte";
  import CardTOC from './CardTOC.svelte';
  import {shortDate, removeun} from  './helpers.js';
  // import {removeun} from  './helpers.js';
  export let newsletterId=0;
  import { fade } from 'svelte/transition';
  import {getContext} from 'svelte';

  const db = getContext('firebase').getFirebase().firestore();

  // code for displaying one or two columns
  let newHtml="<p></p>";
  let newSubject='';
  let newFrom='';
  let pubDate='';
  let newPubId='';
  let newToc=null;

  const showPage = function(id){
    // with id get html
    if (id == "" || id == undefined){return};
    // console.log("id="+id);
    let docRef=db.collection("newsletters").doc(id);
    docRef.get().then(function(doc) {
      if (doc.exists) {
          // console.log("Document data:", doc.data());
          // with the html then open new tab

          newHtml=removeun(doc.data()["stripped-html"], id.split('_')[0]);
          newSubject=doc.data()["subject"];
          newFrom=doc.data()["from"].split('<')[0]
          pubDate=shortDate(doc.data()["timestamp"]);
          newPubId=id.split('_')[0];
          newToc = doc.data()["toc"];
          // console.log('newPubId='+newPubId);

          // let msg=open("",'_blank',"toolbar,directories=no,menubar");
          // msg.document.write(removeun(doc.data()["stripped-html"]));
      } else {
          // doc.data() will be undefined in this case
          console.log("No such document! id="+id);
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });
    return
  }
  $: showPage(newsletterId);
  console.log('@Issue newsletterId='+newsletterId)
</script>

<svelte:head>
  <meta property="og:title" content="{newSubject} ({pubDate})">
  <meta property="og:description" content="Newsletter from {newFrom}">
  <meta property="og:url" content="https://reading.email/newsletter/{newsletterId}">
  <meta property="og:site_name" content="{newFrom} on Reading.email">
</svelte:head>




{#if newsletterId==0}
  <About></About>
{:else}
  <div class="issueheader">
    <div class="newfrom">{newFrom}</div>
    <div class="newsubject">{newSubject}</div>
    <div>{pubDate}</div>
  </div>
  <div class="newsletterHtml" transition:fade>
    {@html newHtml}
  </div>
  {#if Array.isArray(newToc)}
    <div class="toc"> 
      <!-- future display of toc for current newsletter-->
      <!-- <h1>TOC Here</h1>
      <p>{newToc}</p> -->
      <hr/>
      <CardTOC toc={newToc} expand="expand"></CardTOC>
    </div>
  {/if}
  <!-- <p>Newsletter issues displayed here for {newsletterId}</p> -->
{/if}


<style>
  .issueheader {text-align: center;  padding: 0.5rem;}
  .newfrom {font-weight: bold; font-size: 1rem;}
  .newsubject {font-weight: bold; font-size: 1.4rem;}
  .newsletterHtml {max-width: 600px;}
  .toc {margin-left: 1rem;}
</style>